<script lang="ts" setup>
defineProps({
  center: {
    default: false,
    type: Boolean,
  },
  direction: {
    default: 'vertical',
    type: String as PropType<LayoutSectionDirection>,
  },
  hasPadding: {
    default: true,
    type: Boolean,
  },
  reverse: {
    default: false,
    type: Boolean,
  },
})

const slots = useSlots()
</script>

<template>
  <div
    class="relative flex w-full flex-col gap-12"
    :class="{
      '!p-0': !hasPadding,
      'xl:flex-row': direction === 'horizontal',
      'xl:justify-center': direction === 'horizontal' && center,
      'xl:flex-row-reverse': direction === 'horizontal' && reverse,
    }"
  >
    <slot />

    <div
      v-if="slots.left"
      class="text-center"
      :class="{
        'xl:mb-0 xl:text-left': direction === 'horizontal',
        'xl:flex-1': direction === 'horizontal' && !center,
        'xl:flex-initial': direction === 'horizontal' && center,
        'xl:ml-16': direction === 'horizontal' && reverse && slots.right,
        'xl:mr-16': direction === 'horizontal' && !reverse && slots.right,
      }"
    >
      <slot name="left" />
    </div>

    <div
      v-if="slots.right"
      class="flex-initial"
    >
      <slot name="right" />
    </div>
  </div>
</template>
